<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-6': mobile,
          'pt-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">Update Lease Period</p>
        <v-form v-model="isFormValid">
          <v-row>
            <v-col class="py-0" md="3">
              <p class="caption">Unit:</p>
            </v-col>
            <v-col class="py-0" md="9">
              <p class="caption font-weight-bold">{{ bedName }}</p>
            </v-col>
          </v-row>
          <v-divider class="mt-4 mb-6"></v-divider>
          <v-row v-for="(period, index) in contractPeriods" :key="index">
            <v-col class="py-0" cols="12" sm="12" md="4">
              <v-menu
                v-model="period.moveInDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="period.moveInDate"
                    label="Start Date"
                    v-bind="attrs"
                    outlined
                    dense
                    v-on="on"
                    @click="setDateIndex(index)"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="period.moveInDate"
                  :allowed-dates="allowedDatesMoveIn"
                  no-title
                  scrollable
                  @input="period.moveInDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="4">
              <v-menu
                v-model="period.moveOutDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="period.moveOutDate"
                    label="End Date"
                    v-bind="attrs"
                    outlined
                    dense
                    v-on="on"
                    @click="setDateIndex(index)"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="period.moveOutDate"
                  :allowed-dates="allowedDatesMoveOut"
                  no-title
                  scrollable
                  @input="period.moveOutDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="py-0" cols="12" sm="12" md="4">
              <v-currency-field
                v-model="period.rentFee"
                type="number"
                :rules="rentFeeRules"
                label="Rent Fee"
                :append-outer-icon="!mobile ? 'mdi-close' : null"
                outlined
                dense
                required
                @click:append-outer="removePeriod(index)"
              >
                <template v-slot:prepend-inner>
                  <v-icon small class="mt-1">mdi-cash</v-icon>
                </template>
              </v-currency-field>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col class="py-0" cols="12" sm="12" md="4">
              <v-btn text x-small color="primary" @click="addPeriod">
                <v-icon left x-small>mdi-plus-circle</v-icon> Add another period
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-select
                v-model="daysBeforeNotif"
                :items="daysBeforeNotifItems"
                label="Remind me:"
                required
                multiple
                outlined
                :dense="!mobile"
                chips
                small-chips
              >
                <template v-slot:prepend-inner>
                  <v-icon small class="mt-1">mdi-calendar-today</v-icon>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions :class="{ 'pt-6': !mobile }">
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            :disabled="!isFormValid"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data: () => ({
    // bedsList: [],
    tenantId: -1,
    bedId: -1,
    leaseId: -1,
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 700,
      zIndex: 200
    },
    daysBeforeNotif: [1, 7],
    moveInDate: dayjs()
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    moveOutDate: dayjs()
      .add(1, 'year')
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DD'),
    date: new Date().toISOString().substr(0, 10),
    moveInDateMenu: false,
    moveOutDateMenu: false,
    rentFeeRules: [
      (v) => !!v || 'Rent Fee is Required.',
      (v) => Number.isInteger(parseInt(v)) || 'Rent Fee must be a number.'
      // v => v > 0 || 'Rent Fee must be greater than 0'
    ],
    daysBeforeNotifItems: [
      { value: 1, text: '1 day before' },
      { value: 7, text: '1 week before' },
      { value: 14, text: '2 weeks before' },
      { value: 30, text: '30 days before' }
    ],
    contractPeriods: [],
    dateIndex: -1,
    isFormValid: false,
    bedName: ''
  }),
  computed: {
    selectedBed() {
      return this.$store.getters['units/getSelectedBed']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    async open(params) {
      await this.$store.dispatch('units/fetchSelectedBedAction', params.bedId)
      this.bedName = params.bedName
      this.tenantId = params.tenantId
      this.bedId = params.bedId
      this.leaseId = params.leaseId
      this.daysBeforeNotif = this.selectedBed.daysBeforeNotif
      if (this.selectedBed.contractPeriods) {
        this.contractPeriods = this.selectedBed.contractPeriods.map(
          (period) => {
            const value = {}
            value.moveInDate = dayjs(period.moveInDate).format('YYYY-MM-DD')
            value.moveInDateMenu = false
            value.moveOutDate = dayjs(period.moveOutDate).format('YYYY-MM-DD')
            value.moveOutDateMenu = false
            value.rentFee = period.rentFee
            return value
          }
        )
      } else {
        this.contractPeriods = [
          {
            moveInDate: dayjs(this.selectedBed.moveInDate).format('YYYY-MM-DD'),
            moveInDateMenu: false,
            moveOutDate: dayjs(this.selectedBed.moveOutDate).format(
              'YYYY-MM-DD'
            ),
            moveOutDateMenu: false,
            rentFee: this.selectedBed.rentFee
          }
        ]
      }

      this.dialog = true
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
    async finish() {
      let formattedContractPeriods = JSON.parse(
        JSON.stringify(this.contractPeriods)
      ) // deep copy

      formattedContractPeriods = formattedContractPeriods.map((period) => {
        period.moveInDate = dayjs(period.moveInDate).format()
        period.moveOutDate = dayjs(period.moveOutDate).format()
        return period
      })

      await this.$store.dispatch('units/renewLeaseAction', {
        leaseId: this.leaseId,
        contractPeriods: formattedContractPeriods,
        daysBeforeNotif: this.daysBeforeNotif
      })
      this.resolve(true)
      this.dialog = false
      this.$root
        .$confirm({
          title: 'Update Lease Period',
          message: `The lease has been updated.`,
          reconfirmOnly: true,
          confirmText: 'OK'
        })
        .then(async () => {
          window.location.reload()
        })
    },
    allowedDatesMoveOut(val) {
      const moveInDate = this.contractPeriods[this.dateIndex].moveInDate
      return dayjs(val).isAfter(dayjs(moveInDate))
      // return parseInt(val.split('-')[2], 10) % 2 === 0
    },
    allowedDatesMoveIn(val) {
      if (this.dateIndex <= 0) return true
      const previousMoveOutDate =
        this.contractPeriods[this.dateIndex - 1].moveOutDate
      return dayjs(val).isAfter(dayjs(previousMoveOutDate))
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    // async getBedsListWithSelected(groups, bedsList, parents) {
    //   for(let group in groups) {
    //     if(groups[group].groups_details && groups[group].groups_details.length) {
    //       await this.getBedsListWithSelected(groups[group].groups_details, bedsList, parents + `${groups[group].groupName} / `)
    //     }
    //     if(groups[group].beds_details) {
    //       for(let bed in groups[group].beds_details) {
    //         if((groups[group].beds_details)[bed].status === 'vacant' || (groups[group].beds_details)[bed].bedId == this.$store.state.units.selectedBed.bedId ) {
    //           bedsList.push({
    //             value: (groups[group].beds_details)[bed].bedId,
    //             text: parents+(groups[group]).groupName + ' / ' + (groups[group].beds_details)[bed].bedName
    //           })
    //         }
    //       }
    //     }
    //   }
    // },
    addPeriod() {
      const lastIndex = this.contractPeriods.length - 1
      const lastContractPeriod = this.contractPeriods[lastIndex]
      const moveInDate = dayjs(lastContractPeriod.moveOutDate).add(1, 'day')
      const moveOutDate = moveInDate.add(1, 'year').subtract(1, 'day')
      this.contractPeriods.push({
        moveInDate: moveInDate.format('YYYY-MM-DD'),
        moveInDateMenu: false,
        moveOutDate: moveOutDate.format('YYYY-MM-DD'),
        moveOutDateMenu: false
      })
    },
    removePeriod(index) {
      if (index <= 0) return
      this.contractPeriods.splice(index, 1)
    },
    setDateIndex(index) {
      this.dateIndex = index
    }
  }
}
</script>
